import { gql } from '@apollo/client'

export const DROP_OFF_ADDRESS_FRAGMENT = gql`
  fragment DropOffAddress on DropOffAddress {
    address1
    address2
    city
    country
    countryIsoCode
    id
    latitude
    longitude
    state
    stateIsoCode
    zipCode
  }
`
